export default class LifeCoverage {
  coverageCode: string | null
  sumInsured: string | null | undefined

  constructor(data: LifeCoverage) {
    if (!data.coverageCode) throw new Error('coverageCode is required')

    this.coverageCode = data.coverageCode
    this.sumInsured = data.sumInsured ? String(data.sumInsured) : undefined
  }
}
